import toast from 'react-hot-toast';

export const showToast = {
    success: (message) => {
        toast.dismiss();
        toast.success(message);
    },
    
    error: (message) => {
        toast.dismiss();
        toast.error(message);
    },

    info: (message, options = {}) => {
        toast.dismiss();
        toast(message, {
            icon: 'ℹ️',
            style: {
                background: '#17a2b8',
                color: '#fff',
            },
            ...options
        });
    },

};